var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6484 33.75H44.8984V11.4619L46.1191 11.2013C46.4121 11.1439 46.6908 11.0288 46.9389 10.8626C47.1871 10.6964 47.3996 10.4825 47.5642 10.2334C47.7288 9.98422 47.8422 9.70478 47.8977 9.41136C47.9532 9.11795 47.9497 8.81642 47.8875 8.52435C47.8253 8.23228 47.7055 7.95552 47.5353 7.7102C47.365 7.46489 47.1476 7.25592 46.8957 7.09548C46.6439 6.93504 46.3626 6.82634 46.0683 6.77573C45.774 6.72511 45.4726 6.73358 45.1816 6.80064L3.18156 15.8006C2.63928 15.9176 2.15934 16.2309 1.83391 16.6801C1.50848 17.1294 1.3605 17.6831 1.41839 18.2348C1.47629 18.7866 1.73597 19.2975 2.14757 19.6694C2.55918 20.0414 3.09368 20.2481 3.64844 20.25C3.80783 20.2503 3.96682 20.234 4.12281 20.2013L4.40031 20.1413V33.75H3.64844C3.0517 33.75 2.4794 33.9871 2.05745 34.409C1.63549 34.831 1.39844 35.4033 1.39844 36C1.39844 36.5968 1.63549 37.1691 2.05745 37.591C2.4794 38.013 3.0517 38.25 3.64844 38.25H45.6484C46.2452 38.25 46.8175 38.013 47.2394 37.591C47.6614 37.1691 47.8984 36.5968 47.8984 36C47.8984 35.4033 47.6614 34.831 47.2394 34.409C46.8175 33.9871 46.2452 33.75 45.6484 33.75ZM8.89844 19.1756L40.3984 12.4256V33.75H36.6484V22.5C36.6484 21.9033 36.4114 21.331 35.9894 20.909C35.5675 20.4871 34.9952 20.25 34.3984 20.25H14.8984C14.3017 20.25 13.7294 20.4871 13.3074 20.909C12.8855 21.331 12.6484 21.9033 12.6484 22.5V33.75H8.89844V19.1756ZM32.1484 27H17.1484V24.75H32.1484V27ZM17.1484 31.5H32.1484V33.75H17.1484V31.5Z",
    fill: "url(#paint0_linear_1559_23132)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_23132",
    x1: 24.6677,
    y1: 6.74316,
    x2: 24.6677,
    y2: 38.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.fb8ea1f487da57b5f6cedaaf923c82d3.svg";
export { ForwardRef as ReactComponent };